import React, { useState } from "react";
import { getTierForSeats } from "../tierPricing";
import { useHttpClient } from "../../shared/hooks/http-hook";

const UpgradeModal = ({
	currentSeats,
	newSeats,
	onClose,
	onUpgrade,
	orgId,
	usedSeats,
}) => {
	const [upgrading, setUpgrading] = useState(false);
	const [error, setError] = useState(null);
	const { sendRequest } = useHttpClient();

	const calculateCost = (seats) => {
		const tier = getTierForSeats(seats);
		return (tier.amount / 100).toFixed(2);
	};

	const handleUpgrade = async () => {
		setUpgrading(true);
		setError(null);
		try {
			const response = await sendRequest(
				`/api/subscriptions/change-tier`,
				"POST",
				JSON.stringify({ seats: newSeats }),
				{
					"Content-Type": "application/json",
					Authorization: `Bearer ${localStorage.getItem("token")}`,
					"X-Org-Id": orgId,
				}
			);

			const data = response?.data;
			if (data) {
				if (onUpgrade) {
					await onUpgrade();
				}
				alert("Subscription upgraded successfully!");
				onClose();
			} else {
				throw new Error("Failed to upgrade subscription");
			}
		} catch (error) {
			if (
				error.message?.includes("payment_action_required") ||
				error.message?.includes("invoice_open_unpaid")
			) {
				// show banner + link to open portal
				setError(
					"We need you to verify/update your payment method to complete this change. Open Billing Portal."
				);
				// optionally trigger /api/subscriptions/:orgId/portal right away
			} else {
				setError(error.message);
			}
		} finally {
			setUpgrading(false);
		}
	};

	const handleOverlayClick = (e) => {
		if (e.target === e.currentTarget) {
			onClose();
		}
	};

	return (
		<div className="modal-overlay" onClick={handleOverlayClick}>
			<div className="modal-content">
				<div className="modal-header">
					<h3>Upgrade Your Plan</h3>
					<button onClick={onClose} className="close-btn">
						×
					</button>
				</div>

				<div className="modal-body">
					<p>You need more seats to invite additional team members.</p>

					<div className="pricing-comparison">
						<div className="current-plan">
							<div>Current: {currentSeats} seats</div>
							<div>${calculateCost(currentSeats)}/month</div>
						</div>
						<div className="new-plan">
							<div>New: {newSeats} seats</div>
							<div>${calculateCost(newSeats)}/month</div>
						</div>
						<div className="cost-difference">
							<strong>
								Additional: $
								{(
									calculateCost(newSeats) - calculateCost(currentSeats)
								).toFixed(2)}
								/month
							</strong>
						</div>
					</div>
					{error && <div className="error-message">{error}</div>}
					{newSeats < currentSeats && usedSeats > newSeats && (
						<div className="warning-banner">
							Please unassign seats to {newSeats} before downgrading. You're
							using {usedSeats}.
							<a href="/team" className="inline-btn" style={{ marginLeft: 8 }}>
								Go to Team
							</a>
						</div>
					)}
				</div>

				<div className="modal-footer">
					<button onClick={onClose} className="cancel-btn">
						Cancel
					</button>
					<button
						onClick={handleUpgrade}
						disabled={upgrading}
						className="upgrade-btn"
					>
						{upgrading ? "Upgrading..." : "Confirm Change"}
					</button>
				</div>
			</div>
		</div>
	);
};

export default UpgradeModal;
